<div class="relative block" [class.animate-pulse]="loading()">
    <sh-dropdown
        #dropdown
        [label]="label()"
        [disabled]="loading() || disabled() || isDisabled()"
        [hint]="hint()"
        [attr.multi-select]="multiSelect() ? true : null"
        [attr.mandatory]="mandatory() ? true : null"
        [attr.condensed]="condensed() ? true : null"
        [attr.error]="error() ? true : null"
        [attr.error-message]="errorMessage()"
        [attr.editable]="searchable() && !useExternalSearch() ? true : null"
        display="label"
        [class]="class()"
    >
        @if (useExternalSearch()) {
            <div
                class="flex items-center gap-1 py-2 sticky top-0 bg-shui-base-4 z-10"
                (click)="$event.stopPropagation()"
            >
                <sh-search
                    type="text"
                    [label]="'common.general.search' | translate"
                    condensed
                    [value]="searchQuery()"
                    (input)="onSearchInput($event)"
                    (keydown)="$event.stopPropagation()"
                    placeholder="Search…"
                />
                @if (searchQuery()) {
                    <sh-icon button icon="cancel" size="xs" (click)="clearSearch()"></sh-icon>
                }
            </div>
        }
        @for (option of visibleOptions(); track option.value) {
            <sh-menu-item
                [attr.data-testid]="optionTestId() ? optionTestId() + '-' + option.value : null"
                [label]="option.label | translate"
                [value]="option.value"
                [disabled]="option.disabled || false"
                [active]="isOptionActive(option.value)"
                (click)="handleMenuItemClick(option.value)"
            ></sh-menu-item>
        }
    </sh-dropdown>
</div>
